import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Divider } from "semantic-ui-react";
import LoadResolver from "components/LoadResolver";
import { toast } from "../Toast/Toast";
import { getAgencys, getUsers } from "store/selectors";
import { AgencyType } from "models";
import { MediaAgencyForm } from "forms/MediaAgency";
import { MediaAgencyTable } from "../MediaAgencyTable/MediaAgencyTable";

export const MediaAgencyEditor = ({ dispatch, t }) => {
  const [isMediaAgencyFormOpen, setIsMediaAgencyFormOpen] = useState(false);
  const [mediaAgencyToUpdate, setMediaAgencyToUpdate] = useState(null);

  useEffect(() => {
    dispatch.agencys.load(AgencyType.MEDIA_AGENCY);
    dispatch.users.init();
  }, []);

  const agencys = useSelector(getAgencys);
  const users = useSelector(getUsers);

  const handleMediaAgencyFormClose = () => {
    setIsMediaAgencyFormOpen(false);
    setMediaAgencyToUpdate(null);
  };

  const handleUpdate = (mediaAgencyToUpdate) => {
    setMediaAgencyToUpdate(mediaAgencyToUpdate);
    setIsMediaAgencyFormOpen(true);
  };

  const handleDelete = async (mediaAgencyToDelete) => {
    try {
      await dispatch.agencys.delete(mediaAgencyToDelete.id);
      toast(undefined, t("media_agency_delete_success"));
    } catch (error) {
      console.error(error);
      toast("error", t("media_agency_delete_failure"));
    }
  };

  return (
    <LoadResolver
      isLoading={agencys.isLoading || users.isLoading}
      error={agencys.error || users.error}
    >
      <div className="page-container">
        <h2>{t("media_agencies")}</h2>
        {isMediaAgencyFormOpen ? (
          <MediaAgencyForm
            mediaAgencyToUpdate={mediaAgencyToUpdate}
            closeMediaAgencyForm={handleMediaAgencyFormClose}
            users={users.items}
            dispatch={dispatch}
            t={t}
          />
        ) : (
          <>
            <Button primary onClick={() => setIsMediaAgencyFormOpen(true)}>
              {t("create_new")}
            </Button>
            <Divider />
            <MediaAgencyTable
              items={agencys.items}
              users={users.items}
              setMediaAgencyToUpdate={setMediaAgencyToUpdate}
              handleUpdate={handleUpdate}
              handleDelete={handleDelete}
              t={t}
            />
          </>
        )}
      </div>
    </LoadResolver>
  );
};
